import React, { useState } from "react";
import { Link, useLocation,useNavigate } from "react-router-dom";
import { useGlobalState } from "../GlobalProvider";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LogoutConfirmationModal from "./LogoutConfirmationModal";
const Sidebar = ({ show, open, closeSidebar }) => {
  const { globalState, setGlobalState } = useGlobalState();
    const navigate = useNavigate();
    const handleLogoutFunc = () => {
      setGlobalState({
        user: null,
        token: null,
        permissions: null,
      });
      toast.success("User logged out successfully");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      navigate("/");
    };
    const [showConfirm, setShowConfirm] = useState(false);
  const [subMenu, setSubMenu] = useState("");
  const location = useLocation();

  const navItems = [
  {
    name: "Dashboard",
    path: "/",
    icon: "dashboard",
  },
  {
    name: "Batches",
    icon: "groups",
    subMenu: [
      {
        name: "Explore",
        path: "/explore-batches",
        icon: "explore",
      },
      {
        name: "My Batches",
        path: "/my-batches",
        icon: "school",
      },
    ],
  },
  {
    name: "Assignments",
    icon: "assignment",
    subMenu: [
      {
        name: "Web Development",
        path: "/web-development",
        icon: "code",
      },
      {
        name: "App Development",
        path: "/app-development",
        icon: "phone_iphone",
      },
    ],
  },
  {
    name: "Certificates",
    path: "/certificated",
    icon: "workspace_premium",
  },
  {
    name: "My Courses",
    icon: "menu_book",
    subMenu: [
      {
        name: "Explore",
        path: "/explore-courses",
        icon: "search",
      },
      {
        name: "My Batches",
        path: "/my-courses",
        icon: "bookmark",
      },
    ],
  },
  {
    name: "Support",
    icon: "support_agent",
    subMenu: [
      {
        name: "Contact",
        path: "/contact",
        icon: "call",
      },
      {
        name: "Ticket",
        path: "/ticket",
        icon: "confirmation_number",
      },
    ],
  },
  {
    name: "Policies",
    icon: "policy",
    subMenu: [
      {
        name: "Terms & Condition",
        path: "/terms-condition",
        icon: "description",
      },
      {
        name: "Privacy Policy",
        path: "/privacy-policy",
        icon: "privacy_tip",
      },
      {
        name: "Cookie Policy",
        path: "/cookie-policy",
        icon: "cookie",
      },
    ],
  },
];

  return (
    <aside
      className={`sidebar d-none d-lg-flex flex-column ${show ? "show" : ""}`}
    >
      {/* Logo */}
      <div className="sidebar-header">
        <div className="logo-box">
          <img src="/assets/images/logo.png" alt="Logo" width="80px" />
        </div>
      </div>

      {/* Navigation */}
      <nav className="nav flex-column flex-nowrap px-3 mt-4 gap-2">
        {/* Dashboard */}
        {navItems?.map((v, i) => {
          if (v?.subMenu) {
            return (
              <>
                <div
                  className="nav-link d-flex justify-content-between align-items-center cursor-pointer"
                  onClick={() => setSubMenu(subMenu == v?.name ? "" : v?.name)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined">{v?.icon}</span>
                    {v?.name}
                  </div>
                  <span
                    className="material-symbols-outlined"
                    style={{ fontSize: "20px" }}
                  >
                    {!subMenu == v?.name ? "expand_less" : "expand_more"}
                  </span>
                </div>

                {/* Dropdown Items for Courses */}
                {subMenu == v?.name && (
                  <div className="ms-4 d-flex flex-column gap-1">
                    {/* Previous Courses - Now a separate route */}
                    {v?.subMenu?.map((value, index) => {
                      return (
                        <Link
                          className={`nav-link small ${
                            location.pathname === value?.path ? "active" : ""
                          }`}
                          to={value?.path}
                          onClick={closeSidebar}
                          key={index}
                        >
                          <span className="material-symbols-outlined">
                            {value?.icon}
                          </span>
                          {value?.name}
                        </Link>
                      );
                    })}
                  </div>
                )}
              </>
            );
          } else {
            return (
              <Link
                className={`nav-link ${location.pathname === v?.path ? "active" : ""}`}
                to="/"
                onClick={closeSidebar}
              >
                <span className="material-symbols-outlined">{v?.icon}</span>
                {v?.name}
              </Link>
            );
          }
        })}
        <Link className={`nav-link text-danger`} onClick={() => setShowConfirm(true)}>
          <span className="material-symbols-outlined">logout</span>
          Logout
        </Link>
      </nav>

      {/* Footer */}
      <div className="sidebar-footer mt-auto">
        <div className="user-card d-flex align-items-center gap-2 p-2">
          <img
            src="https://avatars.githubusercontent.com/u/26342387?v=4"
            alt="Alex"
            width="40"
            className="rounded-circle"
          />
          <div className="user-meta overflow-hidden">
            <p className="mb-0 fw-bold text-truncate">Alex Morgan</p>
            <small className="text-muted text-truncate d-block">
              alex.m@student.edu
            </small>
          </div>
        </div>
      </div>
      <LogoutConfirmationModal
              show={showConfirm}
              handleClose={() => setShowConfirm(false)}
              handleConfirm={handleLogoutFunc}
              title="Logout"
              body="Are you sure you want to logout?"
            />
    </aside>
  );
};

export default Sidebar;
